/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeOrgUnitRequest } from '../../models/change-org-unit-request';
import { PersonDto } from '../../models/person-dto';

export interface ChangeOrgUnit$Params {
      body: ChangeOrgUnitRequest
}

export function changeOrgUnit(http: HttpClient, rootUrl: string, params: ChangeOrgUnit$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonDto>> {
  const rb = new RequestBuilder(rootUrl, changeOrgUnit.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PersonDto>;
    })
  );
}

changeOrgUnit.PATH = '/api/userprofile/change-org-unit';
